module.exports = __webpack_public_path__ + "img/album17_26.ac05f5cd.jpg";